export default __webpack_public_path__ + "static/media/illust-analysis-2@2x.72c4efb1.png";